import { __rest } from "tslib";
import { writable } from 'svelte/store';
export const wm = (() => {
    const { subscribe, set, update } = writable([]);
    return {
        subscribe,
        add: (x) => update(a => {
            const found = a.find(({ title }) => title === x.title);
            if (found) {
                return a.map((_a) => {
                    var { zidx } = _a, rest = __rest(_a, ["zidx"]);
                    return (Object.assign(Object.assign({}, rest), { zidx: zidx < found ? zidx : (zidx > found ? zidx - 1 : a.length - 1) }));
                });
            }
            return [...a, Object.assign(Object.assign({}, x), { zidx: a.length })];
        }),
        remove: (x) => update(a => a.filter(({ title }) => title !== x.title)),
        clear: () => set([]),
    };
})();
